import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {InputBase} from './InputBase';
import {InputControlService} from './inputcontrol.service';

@Component({
    selector:'dynamic-form',
    templateUrl:'./dynamicform.component.html',
    providers:[InputControlService]
})
export class DynamicFormComponent implements OnInit{
    @Input()
    public disabled:boolean = false;

    @Output() updatedForm = new EventEmitter<any>();
    private maxwidth:number = 12;
    public rows:any[]=[];
    public inputFields:InputBase<any>[]=[];
    public form!: FormGroup;
    public payload='';
    public stackInputs:boolean = false;
    
    constructor(private ics: InputControlService){}

    ngOnInit(){
    }

    public setFormInputs(inputFields:any){
        this.clearForm();
        this.inputFields = inputFields;
        this.form = this.ics.toFormGroup(this.inputFields);
        this.calulateRowColumns();
        if(this.rows.length>0){
            this.form.valueChanges.subscribe((data)=>{
                this.update();
            });
        }
        if(inputFields.length>0){
            this.update();
        }

    }
    public toggleStackInputs(tf:boolean){
        this.stackInputs = tf
    }

    public clearForm(){
        for(let i =0; i<this.inputFields.length; i++){
            this.form.removeControl(this.inputFields[i].key);
        }
        this.inputFields=[];
        this.form = this.ics.toFormGroup(this.inputFields);
        this.rows = [];
    }

    private calulateRowColumns(){
        let defaultwidth=3;
        let currentWidth = 0;
        let columns = [];
        for(let i=0; i < this.inputFields.length; i++){
            if(currentWidth+defaultwidth <= this.maxwidth){
                columns.push(this.inputFields[i]);
                currentWidth+=defaultwidth;
            }else{
                this.rows.push(columns);
                columns=[];
                columns.push(this.inputFields[i]);
                currentWidth = 3;
            }
        }
        this.rows.push(columns);
    }

    public update(){
        this.updatedForm.emit(
            Object.keys(this.form.value).map((key)=>{
                let field={fieldId:0, value:''};
                field.fieldId = Number(key);
                field.value =this.form.value[key]
                return field;
            })
        );
    }
}